import React from "react";
import "../../../../componentsUI/tablas/tablaGenerica.css";

export default function TablaCambiosInventario({
  cambiosPendientes,
  onQuitarCambio,
  onAprobarCambios,
}) {
  if (cambiosPendientes.length === 0) return null;

  return (
    <div className="tabla-container-cambios">
      <h3 className="tabla-info-cambios">Aprobar Cambios</h3>

      <div className="tabla-scroll-cambios">
        <table className="tabla-cambios">
          <thead>
            <tr>
              <th className="col-1">Producto</th>
              <th className="col-2">Min</th>
              <th className="col-3">Stock Nuevo</th>
              <th className="col-4">Aprobar</th>
            </tr>
          </thead>

          <tbody>
            {cambiosPendientes.map((cambio) => (
              <tr key={cambio.id_inventario}>
                <td className="col-1">
                  {cambio.id_producto} - {cambio.nombre}
                </td>
                <td className="col-2">{cambio.stock_actual}</td>
                <td className="col-3">{cambio.stock_nuevo}</td>
                <td className="col-4">
                  <button
                    onClick={() => onQuitarCambio(cambio.id_inventario)}
                  >
                    Quitar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="section-aprobar">
          <button className="btn-aprobar" onClick={onAprobarCambios}>
            Aprobar cambios ({cambiosPendientes.length})
          </button>
        </div>
      </div>
    </div>
  );
}
